import type { UmbLocalizationDictionary } from '@umbraco-cms/backoffice/localization-api';

export default {
	auth: {
		friendlyGreeting: 'Hi there',
	},
} satisfies UmbLocalizationDictionary;
